"use client";

import { useState } from "react";

type FilterKey = "all" | "increase" | "reallocate" | "decrease";

const filters: { key: FilterKey; label: string }[] = [
  { key: "all", label: "All 14" },
  { key: "increase", label: "Increase 1" },
  { key: "reallocate", label: "Reallocate 6" },
  { key: "decrease", label: "Decrease 7" },
];

const copy: Record<FilterKey, { title: string; detail: string; value: string }> = {
  all: { title: "Decrease · Brand Search", detail: "Protects $640 of month-end overage", value: "−$420" },
  increase: { title: "Increase · High-intent Generic", detail: "Captures 12 additional qualified leads", value: "+$280" },
  reallocate: { title: "Reallocate · Demand Capture", detail: "Moves budget toward 2.4× return", value: "↔ $610" },
  decrease: { title: "Decrease · Brand Search", detail: "Protects $640 of month-end overage", value: "−$420" },
};

export function BudgetMonitor() {
  const [filter, setFilter] = useState<FilterKey>("all");
  const [amount, setAmount] = useState(420);
  const item = copy[filter];

  return (
    <div className="mini-app app-budget">
      <div className="mini-app-head">
        <div>
          <span className="mini-label">Budget Monitoring</span>
          <strong>Month pacing</strong>
        </div>
        <span className="mini-period">July 2026 ▾</span>
      </div>

      <div className="budget-alert">
        <span className="alert-icon" aria-hidden="true">!</span>
        <span>
          <b>Projected end is $1,623 over budget</b>
          <small>Rebalance before the 24th to stay inside guardrails.</small>
        </span>
        <strong>Review</strong>
      </div>

      <div className="budget-overview">
        <div className="budget-ring" style={{ "--budget": "72%" } as React.CSSProperties}>
          <span>
            <b>72%</b>
            <small>spent</small>
          </span>
        </div>
        <div className="budget-stats">
          <div>
            <span>Spent to date</span>
            <strong>
              $4,982 <em>/ $6,900</em>
            </strong>
          </div>
          <div>
            <span>Days passed</span>
            <strong>
              18 <em>/ 31</em>
            </strong>
          </div>
          <div>
            <span>Projected finish</span>
            <strong className="overage">
              $8,523 <em>+23%</em>
            </strong>
          </div>
        </div>
      </div>

      <div className="budget-filters">
        {filters.map((f) => (
          <button key={f.key} type="button" className={filter === f.key ? "is-active" : ""} onClick={() => setFilter(f.key)} aria-pressed={filter === f.key}>
            {f.label}
          </button>
        ))}
      </div>

      <div className="budget-recommendation">
        <span className="action-dot coral" aria-hidden="true" />
        <span>
          <b>{item.title}</b>
          <small>{item.detail}</small>
        </span>
        <strong>
          {filter === "increase" ? `+$${amount}` : filter === "reallocate" ? "↔ $610" : `−$${amount}`}
          <button type="button" aria-label="Increase recommendation" onClick={() => setAmount((a) => Math.min(900, a + 60))}>
            ↑
          </button>
          <button type="button" aria-label="Decrease recommendation" onClick={() => setAmount((a) => Math.max(120, a - 60))}>
            ↓
          </button>
        </strong>
      </div>
    </div>
  );
}